export default {
  allowCreateQuestions: 'Permitir crear Preguntas',
  allowCreateQuestionsTooltip: 'Esta opción le permite crear los diferentes tipos de preguntas dentro de la {entity}.',
  questionOptions: 'Opciones de Preguntas',
  questionOptionsTooltip: 'Opciones de preguntas que pueden estar dentro de la {entity}.',
  redaction: 'Redacción',
  matching: 'Emparejamiento',
  simpleSelection: 'Selección Simple',
  multipleSelection: 'Selección Múltiple',
}
